import axios from 'axios';

const API_URL = '/api/vehicle-data';

// Get all vehicle data
export const getAllVehicleData = async () => {
    try {
        const response = await axios.get(API_URL);
        return response.data;
    } catch (error) {
        console.error('Error fetching vehicle data:', error);
        throw error;
    }
};

// Get all brands
export const getBrands = async () => {
    try {
        const response = await axios.get(`${API_URL}/brands`);
        return response.data;
    } catch (error) {
        console.error('Error fetching brands:', error);
        throw error;
    }
};

// Get models by brand
export const getModelsByBrand = async (brand) => {
    try {
        const response = await axios.get(`${API_URL}/models/${brand}`);
        return response.data;
    } catch (error) {
        console.error(`Error fetching models for brand ${brand}:`, error);
        throw error;
    }
};

// Get all body types
export const getBodyTypes = async () => {
    try {
        const response = await axios.get(`${API_URL}/types`);
        return response.data;
    } catch (error) {
        console.error('Error fetching body types:', error);
        throw error;
    }
};

// Import vehicle data (admin only)
export const importVehicleData = async (data) => {
    try {
        const token = localStorage.getItem('token');
        const response = await axios.post(
            `${API_URL}/import`,
            data,
            {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`
                }
            }
        );
        return response.data;
    } catch (error) {
        console.error('Error importing vehicle data:', error);
        throw error;
    }
};